const getPaymentRequestStatus = (status) => {
    switch(status) {
        case 'done':
            return <span className="bg-success inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">تم الدفع</span>;
        case 'pending':
            return <span className="bg-danger inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">لم يتم الدفع</span>;
        case 'timed-out':
            return <span className="bg-danger inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">انتهي الوقت</span>;
        case 'active':
            return <span className="bg-darkBlue inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">نشط</span>;
        case 'pending-approval':
            return <span className="bg-orange inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">في انتظار اعتماد الطلب</span>;
        case 'canceled':
            return <span className="bg-danger inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">ملغي</span>;
        case 'rejected':
            return <span className="bg-danger inline-block text-white leading-[25px] h-[25px] px-[8px] rounded-[30px] text-[14px] font-[500]">مرفوض</span>;
        default:
            return '';
    }
}


export { getPaymentRequestStatus };
